<template>
    <ly-auto-input
        :placeholder="placeholder"
        icon="information"
        width="100%"
        :size="json.size"
        :fetch-suggestions="fetchSuggestions"
        :dropdown-width="dropdownWidth"
        :dropdown-fields="bindHead"
        v-model="value[json.prop]"
        @keydown.up.native.preven="keydownFn"
        @keydown.down.native.preven="keydownFn"
        @change="autoChange"
        @focus="autoFocus"
        ref="autoInput">
    </ly-auto-input>
</template>
<script>
    /**
     * 货品信息搜索组件
     * @author zjs
     * @time 2017-09-12
     */
    import LyAutoInput from '@c/autoinput'
    export default {
        name: 'LyAutoProduct',
        components: {
            LyAutoInput
        },
        props: {
            // value是一个customer对象
            value: Object,
            /**
                客户信息 相关的配置
                json 示例：
                {
                    prop: 'customer_name'  
                } // prop 指定要绑定对象中哪个字段的值
             */
            json: Object,
            // 结果列表面板的宽度
            dropdownWidth: {
                type: String,
                default: '601px'
            },
            // 标识是否有仓库
            hasWarehouse: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: '请输入'
            },
            storeId: {
                type: [String, Number],
                default: ''
            }
        },
        watch: {
            storeId (id) {
                // 仓库变化清空选择
                this.autoChange({}) 
            }
        },
        data () {
            return {
                bindHead: [], // 绑定到表格上的表头
                baseHead: [{
                    "label":"货品编码",
                    "prop":"product_cai",
                    "width": 120
                },{
                    "label":"货品名称",
                    "prop":"product_name",
                    "width": 420
                },{
                    "label":"单位",
                    "prop":"product_unit",
                    "width": 60
                }], // 表头基本配置,此配置应该是读取到后端的
                // 需要显示的仓库字段
                warehouseHead: [],
                lastKeyword: '', // 上一次查询的关键字
                dataCount: 0 // 记录当前数据列表的数据
            }
        },
        methods: {
            /**
             * 2019-09-06添加，
             * 监听输入框的上下键，在外层也能监听，这里是监听后获得查询出来的数据长度
             * 如果有数据，上下键是用来选择数据的，而不是用来跨行
             */
            keydownFn () {
                this.$emit('count', this.dataCount)
            },
            /**
             * 数据的查找
             * @param {[String]} keyword [查询的关键字]
             * @param {[Function]} callback [查询后的回调]
             */
            fetchSuggestions (keyword, callback) {
                this.lastKeyword = keyword
                let data = {
                    store_id: this.storeId // 指定查询的仓库
                }
                data[this.json.prop] = keyword
                this.$api.product.query(data).then((rs) => {
                    this.dataCount = rs.product.length
                    this.warehouseRender(rs.product) // 仓库数据展开处理
                    callback(rs.product)
                }).catch((err) => {
                    console.error('auto-product query error:%O', err)
                })
            },
            /**
             * 焦点获得的监听
             * @return {[type]} [description]
             */
            autoFocus () {
                if (this.lastKeyword.length < 1 && this.dataCount < 1) {
                    // this.$refs.autoInput.getData('')  // 取消了默认获取数据
                }
            },
            /**
             * 选中的数据
             * @param  {[type]} row [description]
             * @return {[type]}     [description]
             */
            autoChange (row) {
                if (row !== this.value) {
                    this.$emit('input', row)
                }
            },
            /**
             * 仓库数据 二维数组展开成 一维数组的处理
             * @param  {[type]} rs [description]
             * @return {[type]}    [description]
             */
            warehouseRender (rs) {
                this.bindHead = [] // 表头清空
                this.warehouseHead = [] // 仓库标头
                let count = 0
                if (this.hasWarehouse && rs && rs.length > 0) {
                    for (let i in rs) {
                        if (rs[i].warehouse && rs[i].warehouse.length > 0) {
                            // 遍历仓库,将二维转为一维
                            for (let j in rs[i].warehouse) {
                                // 组合此仓库数量的字段
                                let field = 'warehouse_' + j + '_quantity'
                                rs[i][field] = rs[i].warehouse[j]['quantity']
                                // 取第一条数据的仓库数据，作为表格显示的表头内容
                                if (count === 0) {
                                    this.warehouseHead.push({
                                        "label": rs[i].warehouse[j].name,
                                        "prop": field,
                                        "width": rs[i].warehouse[j].name.length * 25
                                    })   
                                }
                            }
                            count++
                        }
                    }
                }
                this.bindHead = this.baseHead.concat(this.warehouseHead)
            }
        }
    }
</script>